import { Link } from "react-router-dom";
import type { Movie } from "@/types/movie";
import SectionHeader from "@/components/feature/SectionHeader";

interface HotRailProps {
  movies: Movie[];
}

export default function HotRail({ movies }: HotRailProps) {
  return (
    <section className="mx-auto w-full max-w-[1440px] px-4 pt-12 md:px-8 md:pt-16">
      <SectionHeader
        title="本周热播剧"
        subtitle="策划专题 · 综合热度与口碑，为你挑选本周最值得追的影视作品"
        moreTo="/category"
      />
      <div className="rail-scroll flex snap-x gap-4 overflow-x-auto pb-4 md:gap-6">
        {movies.map((movie, i) => (
          <Link
            key={movie.id}
            to={`/detail/${movie.id}`}
            className="group relative w-64 shrink-0 cursor-pointer snap-start overflow-hidden rounded-lg md:w-80"
          >
            <div className="relative h-40 w-full overflow-hidden md:h-48">
              <img
                src={movie.backdrop}
                alt={`${movie.title} 专题图`}
                title={`${movie.title} - 本周热播 - 97影院`}
                className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-primary-950/90 to-transparent" />
              <span className="absolute left-3 top-3 flex h-7 w-7 items-center justify-center rounded-md bg-accent-500 text-sm font-bold text-primary-950">
                {i + 1}
              </span>
              <div className="absolute inset-x-3 bottom-3">
                <h3 className="truncate font-heading text-base font-bold text-background-50">{movie.title}</h3>
                <div className="mt-1 flex items-center gap-2 text-xs text-background-200">
                  <span>{movie.genre}</span>
                  <span>·</span>
                  <span>{movie.year}</span>
                  <span className="ml-auto flex items-center gap-1 text-accent-400">
                    <i className="ri-fire-fill" />
                    {(movie.heat / 1000).toFixed(1)}k
                  </span>
                </div>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}